import { Tag } from "@blueprintjs/core";
import type { ReactNode } from "react";

export const PhonebookFormSection = ({
  title,
  eyebrow,
  children,
  rightContent,
}: {
  title: string;
  eyebrow?: string;
  children: ReactNode;
  rightContent?: ReactNode;
}) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <header className="mb-4 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-xs font-semibold uppercase text-slate-500">
            {eyebrow}
          </div>
        )}
        <h3 className="mt-1 text-base font-semibold text-slate-950">
          {title}
        </h3>
      </div>
      {rightContent}
    </header>
    {children}
  </section>
);

export const PhonebookEmptyValue = () => (
  <span className="text-sm font-semibold text-slate-400">-</span>
);

export const PhonebookTokenList = ({
  items,
  readOnly,
  onRemove,
}: {
  items: string[];
  readOnly: boolean;
  onRemove: (index: number) => void;
}) => (
  <div className="mt-3 flex min-h-9 flex-wrap items-center gap-2">
    {items.length === 0 && <PhonebookEmptyValue />}

    {items.map((item, index) => (
      <Tag
        className="!bg-slate-100 !px-2.5 !py-1 !text-slate-700"
        interactive={false}
        key={`${item}-${index}`}
        large
        minimal={readOnly}
        onRemove={readOnly ? undefined : () => onRemove(index)}
      >
        {item}
      </Tag>
    ))}
  </div>
);
